import axios from "axios";

import { API_BASE_URI } from 'utils/setting'

const instance = axios.create({
    baseURL: API_BASE_URI,
    headers: {
        'Access-Control-Allow-Methods': 'HEAD, GET, POST, PUT, PATCH, DELETE',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    },
});

instance.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    console.log(error);
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    return Promise.reject(error);
});

export default instance;